<div class="form-wrap">
  <form [formGroup]="templateForm">
    <h2>
      <span *ngIf="!selectedData.templateId">Create</span>
      <span *ngIf="selectedData.templateId">Update</span>
      Column Template
    </h2>

    <div class="flex flex-col">
      <div class="form-field-label">
        <label>Template Name</label>
      </div>
      <mat-form-field appearance="outline">
        <input type="text" matInput formControlName="templateName" />
      </mat-form-field>
    </div>
  </form>

  <div class="flex flex-col" *ngIf="selectedData && selectedData.templateId">
    <div class="form-field-label">
      <label>Columns</label>
    </div>
    <div style="max-height: 300px;" class="overflow-y-scroll">
      <div *ngFor="let col of selectedData.templateList; let i = index" style="margin-bottom: 8px;">
        <mat-checkbox [ngModel]="col.checked" (change)="onCheckboxChange(col, $event)">
          {{ col.name }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="button-wrap">
    <button mat-stroked-button color="primary" (click)="submitForm()">Submit</button>
    <button mat-stroked-button color="error" (click)="closeDialog()">Cancel</button>
  </div>
</div>
